import React, { PropsWithChildren } from 'react'

import { useAutoReloadOnVersionChange } from '@/hooks/useAutoReloadOnVersionChange'

const HelperProvider: React.FC<PropsWithChildren> = ({ children }) => {
  useAutoReloadOnVersionChange()

  return <>{children}</>
}

export default HelperProvider
